// ============================================================================
// HINDI TRANSLATIONS - BIBLE TREASURES (खजाने)
// ============================================================================
// आध्यात्मिक खजाने और बाइबिल की बुद्धि के मोती

export const bibleTreasures = [
  {
    type: "बुद्धि_का_मोती",
    content: "जो बुद्धिमानों के संग चलता है वह बुद्धिमान हो जाता है, परन्तु मूर्खों का साथी नाश हो जाता है",
    reference: "नीतिवचन 13:20",
    category: "बुद्धि",
    strongNumbers: {
      "बुद्धिमान": "H2450", // חכם (chakam) = बुद्धिमान, चतुर
      "चलता": "H1980" // הלך (halak) = चलना, जीना
    },
    reflection: "अपने साथियों और गुरुओं को अच्छी तरह चुनने का महत्व"
  },
  {
    type: "दिव्य_खजाना",
    content: "यहोवा टूटे मन वालों के समीप रहता है, और पिसे हुए मन वालों का उद्धार करता है",
    reference: "भजन संहिता 34:18",
    category: "सांत्वना",
    strongNumbers: {
      "समीप": "H7138", // קרוב (qarob) = निकट, पास
      "टूटा_मन": "H7665" // שבר (shabar) = तोड़ना, नष्ट करना
    },
    reflection: "परमेश्वर विशेष रूप से दुःखी लोगों के निकट हैं"
  },
  {
    type: "दिव्य_प्रतिज्ञा",
    content: "क्योंकि मेरे विचार तुम्हारे विचार नहीं हैं, और न तुम्हारे मार्ग मेरे मार्ग हैं, यहोवा की यही वाणी है",
    reference: "यशायाह 55:8",
    category: "दिव्य_रहस्य",
    strongNumbers: {
      "विचार": "H4284", // מחשבה (machashebah) = विचार, योजना
      "मार्ग": "H1870" // דרך (derek) = मार्ग, रास्ता
    },
    reflection: "दिव्य बुद्धि हमारी मानवीय समझ से परे है"
  },
  {
    type: "प्रोत्साहन",
    content: "हियाव बाँधकर दृढ़ हो जा! मत डर, और तेरा मन कच्चा न हो; क्योंकि जहाँ कहीं तू जाए वहाँ तेरा परमेश्वर यहोवा तेरे संग रहेगा",
    reference: "यहोशू 1:9",
    category: "साहस",
    strongNumbers: {
      "दृढ़": "H2388", // חזק (chazaq) = मजबूत होना, दृढ़ रहना
      "साहस": "H553" // אמץ (amats) = साहसी होना
    },
    reflection: "साहस परमेश्वर की निरंतर उपस्थिति से आता है"
  },
  {
    type: "विश्वास_का_रहस्य",
    content: "विश्वास आशा की हुई वस्तुओं का निश्चय, और अनदेखी वस्तुओं का प्रमाण है",
    reference: "इब्रानियों 11:1",
    category: "विश्वास",
    strongNumbers: {
      "विश्वास": "G4102", // πίστις (pistis) = विश्वास, भरोसा
      "निश्चय": "G5287" // ὑπόστασις (hypostasis) = पदार्थ, निश्चितता
    },
    reflection: "विश्वास दृश्य से परे जाता है और अदृश्य को वास्तविक बनाता है"
  },
  {
    type: "प्रकाशन",
    content: "परन्तु जो कोई उस जल में से पीएगा जो मैं उसे दूँगा, वह फिर प्यासा न होगा",
    reference: "यूहन्ना 4:14",
    category: "आध्यात्मिक_जीवन",
    strongNumbers: {
      "जल": "G5204", // ὕδωρ (hydor) = पानी
      "प्यासा": "G1372" // διψάω (dipsao) = प्यासा होना
    },
    reflection: "यीशु शाश्वत आध्यात्मिक संतुष्टि प्रदान करते हैं"
  },
  {
    type: "दिव्य_विरासत",
    content: "और यदि हम सन्तान हैं, तो वारिस भी, वरन् परमेश्वर के वारिस और मसीह के संगी वारिस हैं",
    reference: "रोमियों 8:17",
    category: "पहचान",
    strongNumbers: {
      "वारिस": "G2818", // κληρονόμος (kleronomos) = उत्तराधिकारी
      "सन्तान": "G5043" // τέκνον (teknon) = बच्चा, संतान
    },
    reflection: "परमेश्वर की संतान और उत्तराधिकारी के रूप में हमारी दिव्य पहचान"
  }
];

export default bibleTreasures;
